define('common/ko/extension/fixedPointNumber',['underscore', 'knockout'], function (_, ko) {
    ko.extenders.fixedPointNumber = function (source, fractionalNumbers) {

        return ko.pureComputed({
            read: function () {
                var value = parseFloat(source());

                return _.floor(value, fractionalNumbers);
            },
            write: function (value) {
                source(value);
            }
        });
    };
});

